export const SITE = {
  domain: "https://bakmiaboen.com",
  name: "Bakmi Aboen",
  established: "1962",
  address: {
    street: "Jl. Gang Kelinci No. 16 (Jl. Belakang Kongsi)",
    area: "Pasar Baru, Sawah Besar",
    city: "Jakarta Pusat",
    region: "DKI Jakarta",
    country: "Indonesia",
  },
  phoneDisplay: "(021) 380 2588",
  phoneHref: "tel:+62213802588",
  hoursDisplay: "Setiap hari, 10.00–22.00 WIB",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Bakmi+Aboen+Gang+Kelinci+Pasar+Baru+Jakarta+Pusat",
  ogImage: "https://bakmiaboen.com/og.png",
};

export const fullAddress = `${SITE.address.street}, ${SITE.address.area}, ${SITE.address.city}, ${SITE.address.region}`;

export const ROUTES = [
  {
    path: "/",
    title: "Bakmi Aboen — Kedai Bakmi Legendaris Pasar Baru, Jakarta (Sejak 1962)",
    description:
      "Bakmi Aboen adalah kedai bakmi Tionghoa-Indonesia di Gang Kelinci, Pasar Baru, Jakarta Pusat, yang berdiri sejak 1962. Lihat menu, jam buka, dan cara menemukan kami.",
    label: "Beranda",
  },
  {
    path: "/menu/",
    title: "Menu Bakmi Aboen — Bakmi, Pangsit Goreng & Hidangan Peranakan",
    description:
      "Daftar menu Bakmi Aboen Pasar Baru: bakmi campur spesial, bakmi babi kecap, pangsit goreng, bakso goreng, sui kiau, bihun, kwetiaw, dan nasi goreng. Menu non-halal.",
    label: "Menu",
  },
  {
    path: "/tentang/",
    title: "Tentang Bakmi Aboen — Kedai Bakmi Sejak 1962 di Pasar Baru",
    description:
      "Cerita Bakmi Aboen, kedai bakmi yang berdiri sejak 1962 di Gang Kelinci, Pasar Baru, Jakarta Pusat — resep yang dijaga lintas generasi di kawasan belanja tertua Jakarta.",
    label: "Tentang",
  },
  {
    path: "/lokasi/",
    title: "Lokasi & Jam Buka — Bakmi Aboen, Gang Kelinci, Pasar Baru",
    description:
      "Alamat Bakmi Aboen: Jl. Gang Kelinci No. 16, Pasar Baru, Jakarta Pusat. Buka setiap hari pukul 10.00–22.00 WIB. Petunjuk arah dan cara menemukan kedai kami.",
    label: "Lokasi",
  },
  {
    path: "/kontak/",
    title: "Kontak Bakmi Aboen — Telepon & Alamat Kedai di Pasar Baru",
    description:
      "Hubungi Bakmi Aboen Pasar Baru melalui telepon (021) 380 2588 atau kunjungi kedai kami di Jl. Gang Kelinci No. 16, Jakarta Pusat. Buka setiap hari 10.00–22.00 WIB.",
    label: "Kontak",
  },
  {
    path: "/faq/",
    title: "Pertanyaan Umum (FAQ) — Bakmi Aboen Pasar Baru",
    description:
      "Jawaban atas pertanyaan yang sering diajukan tentang Bakmi Aboen: status halal, lokasi Gang Kelinci, jam buka, menu andalan, dan pesan antar.",
    label: "FAQ",
  },
];

export const MARQUEE_ITEMS = [
  "Sejak 1962",
  "Gang Kelinci",
  "Pasar Baru",
  "Bakmi Babi Kecap",
  "Pangsit Goreng",
  "Bakso Goreng",
  "Sui Kiau",
  "Non-Halal",
  "Setiap Hari 10.00–22.00",
];

export const SIGNATURES = [
  {
    no: "01",
    name: "Bakmi Campur Spesial",
    desc: "Ayam dan babi kecap bertemu jamur dalam satu mangkuk — perpaduan yang paling banyak dipesan.",
  },
  {
    no: "02",
    name: "Bakmi Babi Kecap",
    desc: "Topping babi kecap gurih-manis di atas bakmi hangat, disiram kaldu ringan.",
  },
  {
    no: "03",
    name: "Pangsit Goreng",
    desc: "Renyah di luar, lembut di dalam. Teman wajib semangkuk bakmi.",
  },
  {
    no: "04",
    name: "Bakso Goreng",
    desc: "Bakso babi goreng dengan tepi yang garing, disajikan hangat.",
  },
  {
    no: "05",
    name: "Sui Kiau",
    desc: "Pangsit rebus berkulit tipis dengan isian gurih.",
  },
];

export const MENU_CATEGORIES = [
  {
    no: "01",
    title: "Bakmi",
    note: "Dengan kaldu ringan dan minyak bawang",
    items: [
      { name: "Bakmi Campur Spesial", desc: "Topping ayam dan babi kecap dengan jamur" },
      { name: "Bakmi Babi Kecap", desc: "Topping babi kecap gurih-manis" },
      { name: "Bakmi Babi Jamur", desc: "Babi kecap dengan jamur merang" },
      { name: "Bakmi Ayam Kecap", desc: "Topping ayam kecap klasik" },
      { name: "Bakmi Ayam Bakso", desc: "Ayam kecap dengan bakso" },
    ],
  },
  {
    no: "02",
    title: "Mie, Bihun & Kwetiaw",
    note: "Digoreng atau berkuah, dengan pilihan ayam atau babi",
    items: [
      { name: "Bakmi Goreng", desc: "Digoreng dengan sayuran dan topping pilihan" },
      { name: "Bihun Goreng", desc: "Bihun tipis goreng gaya Tionghoa" },
      { name: "Kwetiaw Goreng", desc: "Kwetiaw lebar dengan aroma wok" },
    ],
  },
  {
    no: "03",
    title: "Nasi & Hidangan Tionghoa",
    note: "Dimasak saat dipesan",
    items: [
      { name: "Nasi Goreng", desc: "Nasi goreng gaya kedai dengan topping pilihan" },
      { name: "Nasi Ayam Jamur", desc: "Nasi hangat dengan ayam jamur" },
      { name: "Capcai", desc: "Aneka sayuran tumis dengan kuah kental ringan" },
      { name: "Kodok Goreng", desc: "Hidangan klasik kedai Tionghoa lama" },
    ],
  },
  {
    no: "04",
    title: "Lauk & Gorengan",
    note: "Pendamping semangkuk bakmi",
    items: [
      { name: "Pangsit Goreng", desc: "Disajikan hangat, renyah di luar" },
      { name: "Bakso Goreng", desc: "Bakso babi goreng bertepi garing" },
      { name: "Sui Kiau", desc: "Pangsit rebus berkulit tipis" },
      { name: "Tahu Sapi", desc: "Tahu isi daging sapi" },
      { name: "Bakso Sapi", desc: "Bakso daging sapi rebus" },
    ],
  },
];

export const CHAPTERS = [
  {
    no: "Bab 01",
    title: "Di Ujung Gang Kelinci",
    body: "Dari keramaian Jalan Pasar Baru, beloklah ke Gang Kelinci dan berjalan sampai hampir ke ujungnya. Di sanalah kedai ini berdiri — tidak mencolok, seperti sejak enam dekade lalu.",
  },
  {
    no: "Bab 02",
    title: "Resep yang Dijaga",
    body: "Sejak 1962, dapur kecil ini menyalak setiap pagi. Kaldu, kecap, dan topping disiapkan dengan cara yang diturunkan dari generasi ke generasi — tanpa banyak berubah.",
  },
  {
    no: "Bab 03",
    title: "Apa Adanya",
    body: "Kedai ini tidak berusaha menjadi apa pun selain dirinya sendiri: semangkuk bakmi, meja-meja sederhana, dan gang yang ramai terutama pada akhir pekan.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "Apakah Bakmi Aboen halal?",
    a: "Tidak. Bakmi Aboen adalah kedai non-halal — sebagian besar menu kami mengandung babi, seperti topping babi kecap dan bakso goreng babi.",
  },
  {
    q: "Di mana lokasi Bakmi Aboen tepatnya?",
    a: "Kedai kami berada di Jl. Gang Kelinci No. 16 (dikenal juga sebagai Jl. Belakang Kongsi), Pasar Baru, Sawah Besar, Jakarta Pusat. Dari jalan utama Pasar Baru, masuk ke Gang Kelinci dan berjalanlah hingga hampir ke ujung gang.",
  },
  {
    q: "Jam berapa Bakmi Aboen buka?",
    a: "Kami buka setiap hari, Senin sampai Minggu, pukul 10.00 hingga 22.00 WIB.",
  },
  {
    q: "Sejak kapan Bakmi Aboen berdiri?",
    a: "Bakmi Aboen berdiri sejak tahun 1962 dan telah melayani pengunjung Pasar Baru selama lebih dari enam dekade.",
  },
  {
    q: "Apa menu andalan di Bakmi Aboen?",
    a: "Yang paling sering dipesan adalah Bakmi Campur Spesial dengan topping ayam dan babi kecap, ditemani pangsit goreng dan bakso goreng.",
  },
  {
    q: "Apakah bisa pesan antar atau lewat aplikasi?",
    a: "Saat ini kami tidak mencantumkan layanan pesan antar resmi. Cara terbaik menikmati Bakmi Aboen adalah datang langsung ke kedai, atau menelepon (021) 380 2588 untuk pertanyaan.",
  },
];

export const restaurantJsonLd = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "@id": `${SITE.domain}/#restaurant`,
  name: SITE.name,
  url: `${SITE.domain}/`,
  telephone: "+62-21-3802588",
  foundingDate: SITE.established,
  servesCuisine: ["Bakmi", "Masakan Tionghoa Indonesia"],
  address: {
    "@type": "PostalAddress",
    streetAddress: "Jl. Gang Kelinci No. 16, Pasar Baru, Sawah Besar",
    addressLocality: "Jakarta Pusat",
    addressRegion: "DKI Jakarta",
    addressCountry: "ID",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      opens: "10:00",
      closes: "22:00",
    },
  ],
};

export const websiteJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE.domain}/#website`,
  url: `${SITE.domain}/`,
  name: SITE.name,
  inLanguage: "id",
};

export function breadcrumbJsonLd(routePath) {
  const route = ROUTES.find((r) => r.path === routePath);
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Beranda",
        item: `${SITE.domain}/`,
      },
      {
        "@type": "ListItem",
        position: 2,
        name: route.label,
        item: `${SITE.domain}${route.path}`,
      },
    ],
  };
}

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQ_ITEMS.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: { "@type": "Answer", text: item.a },
  })),
};

export function jsonLdFor(routePath) {
  const blocks = [restaurantJsonLd];
  if (routePath === "/") blocks.push(websiteJsonLd);
  if (routePath !== "/") blocks.push(breadcrumbJsonLd(routePath));
  if (routePath === "/faq/") blocks.push(faqJsonLd);
  return blocks;
}
